import {Component, OnInit} from '@angular/core';
import {BasicInformation, HealthRequest, HealthMethods} from '../../../model/SamanHealthFamilyModels';
import {ActivatedRoute, Router} from '@angular/router';
import {HealthInsuranceService} from '../../../services/health-insurance.service';
import {AppSettingsService} from '../../../services/app-settings.service';
import {DateMethods, Response, StaticMethods} from '../../../model/GeneralModels';
import {MatDialog} from '@angular/material/dialog';
import {YesNoDialogComponent} from '../../../Dialogs/yes-no-dialog/yes-no-dialog.component';

@Component({
  selector: 'app-new-health-request',
  templateUrl: './new-health-request.component.html',
  styleUrls: [
    '../../../assets/Content/src/css/lib.vendor.css',
    '../../../assets/Content/src/css/lib.picker.css',
    '../../../assets/Content/src/css/ini.bime.css',
    '../../../assets/vendor/font-awesome-4.7/css/font-awesome.min.css',
    '../../../assets/css/light.theme.css',
  ],
  styles: [`
    /*.main .person .list {*/
    /*    padding: 0 48px 0 48px;*/
    /*}*/
    .main .person .list {
      margin: 17px 17px 17px 17px;
      padding: 12px 45px 20px 12px;
      overflow: hidden;
      position: relative;
      border-radius: 5px;
      background-color: #fff;
      box-shadow: 0 3px 6px rgba(0, 0, 0, 0.24);
      -webkit-animation: flipy 1s both;
      animation: flipy 1s both;
    }
    .main .person .list .item {
      box-shadow: 0 0px 0px rgba(0, 0, 0, .07) !important;
    }
  `]
})
export class NewHealthRequestComponent implements OnInit {
  basicInformation: BasicInformation;
  subRequestList: HealthRequest[] = [];
  submitting = false;
  translatedList: any[] = [];
  confirmationRequired = false;
  private clientKey: string;
  private mobile: string;
  translation: any = {};

  constructor(private router: Router,
              private service: HealthInsuranceService,
              private settings: AppSettingsService,
              private activatedRoute: ActivatedRoute,
              public dialog: MatDialog
  ) {
  }

  ngOnInit() {
    if (StaticMethods.checkState(this.router, 'basicInformation',
      '/health/family/basic-information')) {
      // this.basicInformation = history.state.basicInformation;
      this.subRequestList = history.state.subRequestList;
      this.basicInformation = history.state.basicInformation;
      if (!this.subRequestList) {
        this.subRequestList = [];
      } else {
        this.subRequestList.forEach(subRequest => {
          const i = this.translatedList.length;
          this.translatedList[i] = this.settings.translateObject(subRequest, this.translation);
          this.translatedList[i].original = subRequest;
        });
      }
    }
  }

  openDialog(subRequest): void {
    StaticMethods.openDialog(this.dialog, 'آیا از حذف بیمه گذار مطمئن هستید؟', (result) => {
      if (result) {
        this.subRequestList = this.subRequestList.filter((value, index, arr) => {
          return value !== subRequest;
        });
        this.translatedList = this.translatedList.filter((value, index, arr) => {
          return value.original !== subRequest;
        });
      }
    }, '250px');
  }

  addNewSubRequest() {
    this.router.navigate(['/health/family/new-sub-request'], {
      state: {
        subRequestList: this.subRequestList,
        basicInformation: this.basicInformation
      }
    });
  }

  submit() {
    if (this.subRequestList.length) {
      this.submitting = true;
      this.service.submitHealthRequest(this.basicInformation, this.subRequestList)
        .subscribe((response: Response) => {
          if (response.success) {
            this.translation = StaticMethods.appendTranslation(response.translation, this.translation);
            this.router.navigate(['/health/family/health-offer'], {
              state: {
                requestID: response.data.requestID,
                healthOffers: response.data.healthOffers,
                translation: response.translation,
                subRequestList: this.subRequestList,
                basicInformation: this.basicInformation
              }
            });
          } else {
            this.submitting = false;
            StaticMethods.showError(response.data.message);
          }
        });
    }
  }


  getjalaliDate(birthday: any) {
    return StaticMethods.getjalaliDate(birthday);
  }
}
